import {
 call, put, select, takeEvery,
} from 'redux-saga/effects';
import userAPI from '../../api/UserAPI';
import { FETCH_USER_DATA_REQUEST, SAVE_USER_REQUEST } from '../actions/types/UserActionTypes';
import {
  fetchUserDataFailureActionCreator,
  fetchUserDataSuccessActionCreator,
  saveUserFailureActionCreator,
  saveUserSuccessActionCreator,
} from '../actions/UserActions';
import {
  retrieveAllLeftOperatorsFailureActionCreator,
  retrieveAllLeftOperatorsSuccessActionCreator,
  retrieveAllLeftOperatorsWithImpcsFailureActionCreator,
  retrieveAllLeftOperatorsWithImpcsSuccessActionCreator,
  retrieveAllRightOperatorsFailureActionCreator,
  retrieveAllRightOperatorsSuccessActionCreator,
  retrieveAllRightOperatorsWithImpcsFailureActionCreator,
  retrieveAllRightOperatorsWithImpcsSuccessActionCreator,
  retrieveLeftAssetTypeOperatorsWithImpcsSuccessActionCreator,
  retrieveLeftGlobalImpcPresetFailureActionCreator,
  retrieveLeftGlobalImpcPresetSuccessActionCreator,
  retrieveLeftGlobalOperatorPresetFailureActionCreator,
  retrieveLeftGlobalOperatorPresetSuccessActionCreator,
  retrieveLeftOperatorsByRoleFailureActionCreator,
  retrieveLeftOperatorsByRoleSuccessActionCreator,
  retrieveLeftOperatorsWithImpcsByRoleFailureActionCreator,
  retrieveLeftOperatorsWithImpcsByRoleSuccessActionCreator,
  retrieveRightAssetTypeOperatorsWithImpcsSuccessActionCreator,
  retrieveRightGlobalImpcPresetFailureActionCreator,
  retrieveRightGlobalImpcPresetSuccessActionCreator,
  retrieveRightGlobalOperatorPresetFailureActionCreator,
  retrieveRightGlobalOperatorPresetSuccessActionCreator,
  retrieveRightOperatorsByRoleFailureActionCreator,
  retrieveRightOperatorsByRoleSuccessActionCreator,
  retrieveRightOperatorsWithImpcsByRoleFailureActionCreator,
  retrieveRightOperatorsWithImpcsByRoleSuccessActionCreator,
} from '../../../selection-criteria/operator-impc/redux/actions/OperatorImpcActions';
import {
  RETRIEVE_ALL_LEFT_OPERATORS_REQUEST,
  RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_REQUEST,
  RETRIEVE_ALL_RIGHT_OPERATORS_REQUEST,
  RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_REQUEST,
  RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST,
  RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_REQUEST,
  RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_REQUEST,
  RETRIEVE_LEFT_OPERATORS_BY_ROLE_REQUEST,
  RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST,
  RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST,
  RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_REQUEST,
  RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_REQUEST,
  RETRIEVE_RIGHT_OPERATORS_BY_ROLE_REQUEST,
  RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST,
} from '../../../selection-criteria/operator-impc/redux/actions/types/OperatorImpcActionTypes';
import { languageSelector } from '../../../redux/selectors/languageSelector';
import { showNotification } from '../../../redux/actions/NotificationActions';
import { formatMessage } from '../../../../../locales/locales';
import { logoutAction } from '../../../redux/actions/authActions';

function* saveUser() {
  try {
    yield call(userAPI.postUser);

    yield put(saveUserSuccessActionCreator());
  } catch (e) {
    yield put(saveUserFailureActionCreator(e));
  }
}

function* fetchUserData() {
  try {
    const userDataResponse = yield call(userAPI.getUserData);
    const userData = userDataResponse.data;
    yield put(fetchUserDataSuccessActionCreator(userData));
  } catch (e) {
    yield put(fetchUserDataFailureActionCreator(e));
  }
}

function* retrieveLeftOperatorsWithImpcsByRoleWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const operatorsWithImpcsResponse = yield call(userAPI.getOperatorsWithImpcsByRole);
    yield put(retrieveLeftOperatorsWithImpcsByRoleSuccessActionCreator(operatorsWithImpcsResponse.data));

    if (action.payload.useGlobalPresets) {
      const globalAssetPresetResponse = yield call(userAPI.getGlobalImpcAssetPreset, action.payload.assetType);
      yield put(retrieveLeftGlobalImpcPresetSuccessActionCreator(globalAssetPresetResponse.data));
    }
  } catch (error) {
    yield put(retrieveLeftOperatorsWithImpcsByRoleFailureActionCreator(error));
    if (error.response.status === 500 && error.response.data.message.includes('The Token has expired on')) {
      yield put(showNotification({
        type: 'ERROR',
        message: formatMessage(lang, 'app.login.message.tokenExpired'),
        duration: 20000,
      }));
      yield put(logoutAction());
    }
  }
}

function* retrieveRightOperatorsWithImpcsByRoleWorker(action) {
  try {
    const operatorsWithImpcsResponse = yield call(userAPI.getOperatorsWithImpcsByRole);
    yield put(retrieveRightOperatorsWithImpcsByRoleSuccessActionCreator(operatorsWithImpcsResponse.data));

    if (action.payload.useGlobalPresets) {
      const globalAssetPresetResponse = yield call(userAPI.getGlobalImpcAssetPreset, action.payload.assetType);
      yield put(retrieveRightGlobalImpcPresetSuccessActionCreator(globalAssetPresetResponse.data));
    }
  } catch (error) {
    yield put(retrieveRightOperatorsWithImpcsByRoleFailureActionCreator(error));
  }
}

function* retrieveAllLeftOperatorsWithImpcsWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const operatorsWithImpcsResponse = yield call(userAPI.getAllOperatorsWithImpcs);
    yield put(retrieveAllLeftOperatorsWithImpcsSuccessActionCreator(operatorsWithImpcsResponse.data));

    if (action.payload.useGlobalPresets) {
      const globalAssetPresetResponse = yield call(userAPI.getGlobalImpcAssetPreset, action.payload.assetType);
      yield put(retrieveLeftGlobalImpcPresetSuccessActionCreator(globalAssetPresetResponse.data));
    }
  } catch (error) {
    yield put(retrieveAllLeftOperatorsWithImpcsFailureActionCreator(error));
    if (error.response.status === 500 && error.response.data.message.includes('The Token has expired on')) {
      yield put(showNotification({
        type: 'ERROR',
        message: formatMessage(lang, 'app.login.message.tokenExpired'),
        duration: 20000,
      }));
      yield put(logoutAction());
    }
  }
}

function* retrieveAllRightOperatorsWithImpcsWorker(action) {
  try {
    const operatorsWithImpcsResponse = yield call(userAPI.getAllOperatorsWithImpcs);
    yield put(retrieveAllRightOperatorsWithImpcsSuccessActionCreator(operatorsWithImpcsResponse.data));

    if (action.payload.useGlobalPresets) {
      const globalAssetPresetResponse = yield call(userAPI.getGlobalImpcAssetPreset, action.payload.assetType);
      yield put(retrieveRightGlobalImpcPresetSuccessActionCreator(globalAssetPresetResponse.data));
    }
  } catch (error) {
    yield put(retrieveAllRightOperatorsWithImpcsFailureActionCreator(error));
  }
}

function* retrieveLeftOperatorsByRoleWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const operatorsResponse = yield call(userAPI.getOperatorsWithImpcsByRole);
    yield put(retrieveLeftOperatorsByRoleSuccessActionCreator(operatorsResponse.data));
    if (action.payload.useGlobalPresets) {
      const globalAssetPresetResponse = yield call(userAPI.getGlobalOperatorAssetPreset, action.payload.assetType);
      yield put(retrieveLeftGlobalOperatorPresetSuccessActionCreator(globalAssetPresetResponse.data));
    }
  } catch (error) {
    yield put(retrieveLeftOperatorsByRoleFailureActionCreator(error));
    if (error.response.status === 500 && error.response.data.message.includes('The Token has expired on')) {
      yield put(showNotification({
        type: 'ERROR',
        message: formatMessage(lang, 'app.login.message.tokenExpired'),
        duration: 20000,
      }));
      yield put(logoutAction());
    }
  }
}

function* retrieveRightOperatorsByRoleWorker(action) {
  try {
    const operatorsResponse = yield call(userAPI.getOperatorsWithImpcsByRole);
    yield put(retrieveRightOperatorsByRoleSuccessActionCreator(operatorsResponse.data));
    if (action.payload.useGlobalPresets) {
      const globalAssetPresetResponse = yield call(userAPI.getGlobalOperatorAssetPreset, action.payload.assetType);
      yield put(retrieveRightGlobalOperatorPresetSuccessActionCreator(globalAssetPresetResponse.data));
    }
  } catch (error) {
    yield put(retrieveRightOperatorsByRoleFailureActionCreator(error));
  }
}

function* retrieveAllLeftOperatorsWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const operatorsResponse = yield call(userAPI.getAllOperatorsWithImpcs);
    yield put(retrieveAllLeftOperatorsSuccessActionCreator(operatorsResponse.data));
    if (action.payload.useGlobalPresets) {
      const globalAssetPresetResponse = yield call(userAPI.getGlobalOperatorAssetPreset, action.payload.assetType);
      yield put(retrieveLeftGlobalOperatorPresetSuccessActionCreator(globalAssetPresetResponse.data));
    }
  } catch (error) {
    yield put(retrieveAllLeftOperatorsFailureActionCreator(error));
    if (error.response.status === 500 && error.response.data.message.includes('The Token has expired on')) {
      yield put(showNotification({
        type: 'ERROR',
        message: formatMessage(lang, 'app.login.message.tokenExpired'),
        duration: 20000,
      }));
      yield put(logoutAction());
    }
  }
}

function* retrieveAllRightOperatorsWorker(action) {
  try {
    const operatorsResponse = yield call(userAPI.getAllOperatorsWithImpcs);
    yield put(retrieveAllRightOperatorsSuccessActionCreator(operatorsResponse.data));
    if (action.payload.useGlobalPresets) {
      const globalAssetPresetResponse = yield call(userAPI.getGlobalOperatorAssetPreset, action.payload.assetType);
      yield put(retrieveRightGlobalOperatorPresetSuccessActionCreator(globalAssetPresetResponse.data));
    }
  } catch (error) {
    yield put(retrieveAllRightOperatorsFailureActionCreator(error));
  }
}

function* retrieveLeftGlobalImpcPresetWorker(action) {
  try {
    const response = yield call(userAPI.getGlobalImpcAssetPreset, action.payload);
    yield put(retrieveLeftGlobalImpcPresetSuccessActionCreator(response.data));
  } catch (error) {
    yield put(retrieveLeftGlobalImpcPresetFailureActionCreator(error));
  }
}

function* retrieveRightGlobalImpcPresetWorker(action) {
  try {
    const response = yield call(userAPI.getGlobalImpcAssetPreset, action.payload);
    yield put(retrieveRightGlobalImpcPresetSuccessActionCreator(response.data));
  } catch (error) {
    yield put(retrieveRightGlobalImpcPresetFailureActionCreator(error));
  }
}

function* retrieveLeftGlobalOperatorPresetWorker(action) {
  try {
    const response = yield call(userAPI.getGlobalOperatorAssetPreset, action.payload);
    yield put(retrieveLeftGlobalOperatorPresetSuccessActionCreator(response.data));
  } catch (error) {
    yield put(retrieveLeftGlobalOperatorPresetFailureActionCreator(error));
  }
}

function* retrieveRightGlobalOperatorPresetWorker(action) {
  try {
    const response = yield call(userAPI.getGlobalOperatorAssetPreset, action.payload);
    yield put(retrieveRightGlobalOperatorPresetSuccessActionCreator(response.data));
  } catch (error) {
    yield put(retrieveRightGlobalOperatorPresetFailureActionCreator(error));
  }
}

function* retrieveLeftAssetTypeOperatorsWithImpcsWorker(action) {
  try {
    const response = yield call(userAPI.getAssetTypeOperatorsWithImpcs, action.payload);
    yield put(retrieveLeftAssetTypeOperatorsWithImpcsSuccessActionCreator(response.data));
  } catch (error) {
    yield put(retrieveLeftGlobalImpcPresetFailureActionCreator(error));
  }
}

function* retrieveRightAssetTypeOperatorsWithImpcsWorker(action) {
  try {
    const response = yield call(userAPI.getAssetTypeOperatorsWithImpcs, action.payload);
    yield put(retrieveRightAssetTypeOperatorsWithImpcsSuccessActionCreator(response.data));
  } catch (error) {
    yield put(retrieveRightGlobalImpcPresetFailureActionCreator(error));
  }
}

function* userWatcher() {
  yield takeEvery(SAVE_USER_REQUEST, saveUser);
  yield takeEvery(FETCH_USER_DATA_REQUEST, fetchUserData);
  yield takeEvery(RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST, retrieveLeftOperatorsWithImpcsByRoleWorker);
  yield takeEvery(RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST, retrieveRightOperatorsWithImpcsByRoleWorker);

  yield takeEvery(RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_REQUEST, retrieveAllLeftOperatorsWithImpcsWorker);
  yield takeEvery(RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_REQUEST, retrieveAllRightOperatorsWithImpcsWorker);

  yield takeEvery(RETRIEVE_LEFT_OPERATORS_BY_ROLE_REQUEST, retrieveLeftOperatorsByRoleWorker);
  yield takeEvery(RETRIEVE_RIGHT_OPERATORS_BY_ROLE_REQUEST, retrieveRightOperatorsByRoleWorker);

  yield takeEvery(RETRIEVE_ALL_LEFT_OPERATORS_REQUEST, retrieveAllLeftOperatorsWorker);
  yield takeEvery(RETRIEVE_ALL_RIGHT_OPERATORS_REQUEST, retrieveAllRightOperatorsWorker);

  yield takeEvery(RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_REQUEST, retrieveLeftGlobalImpcPresetWorker);
  yield takeEvery(RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_REQUEST, retrieveRightGlobalImpcPresetWorker);

  yield takeEvery(RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_REQUEST, retrieveLeftGlobalOperatorPresetWorker);
  yield takeEvery(RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_REQUEST, retrieveRightGlobalOperatorPresetWorker);

  yield takeEvery(RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST, retrieveLeftAssetTypeOperatorsWithImpcsWorker);
  yield takeEvery(RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST, retrieveRightAssetTypeOperatorsWithImpcsWorker);
}

export default userWatcher;
